<template>
  <div class="SearchComponent">
    <span v-show="!searchEngineExists">
      <p>{{ lang.infotext_1 }}</p>
    </span>
    <span v-show="searchEngineExists">
      <p>{{lang.infotext_2}}:</p>
      <div class="text-center"   v-show="searchStatus">
        <b-spinner variant="white" :label="lang.loader_Search"></b-spinner>
        <p>{{lang.loader_Search}}...</p>

      </div>
      <div v-show="searchError">{{lang.searchError}}<br><br></div>
      <div v-show="!searchStatus">

        <b-form-input
                type="text"
                @keyup.enter="searchOutside"
                :placeholder="lang.input_placeholder"
                v-model="searchString" >
        </b-form-input><br>

        <b-form-group>

          <b-form-checkbox-group
                                stacked
                                v-model="providers"
                                name="searchparts"
                                :options="searchEngines"
                                class="ml-4"
                                aria-label="Search parts"
          ></b-form-checkbox-group>
        </b-form-group>


        <div>
          <b-button @click="searchOutside" size="sm" class="my-2 my-sm-0 button" :variant="variant">{{lang.button_Search}}</b-button>
          <b-button @click="reset" size="sm" class="my-2 my-sm-0 button" :variant="variant">{{lang.button_Reset}}</b-button>
        </div>

      </div>
      <br>
    </span>
 </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  name: 'SearchComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {


  },
  data () {
    return {
        searchEngineExists: false,
        searchStatus: false,
        searchError: false,
        providers: [],
        searchEngines: [],
        searchString: "",

      }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',


    }),
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
  },
  created () {
    let vue = this;

    this.$store.dispatch("getSearchEnginesBasic")
    .then((result) => {
      console.log(result)
      if (result.status == "OK"){
        if (result.data.length > 0) {
          
          for (let i = 0, lei = result.data.length; i < lei; i++) {
              if (result.data[i].IsActive == true) {
                if (result.data[i].Name !== "Ultra Librarian") {
                  vue.searchEngines.push(result.data[i].Name);
                }
              }
            }
          if (vue.searchEngines.length > 0) {
              vue.searchEngineExists = true;
              vue.initial();
            } else {
              vue.searchEngineExists = false;
            }
            
        } else {
          vue.searchEngineExists = false;
        }
        

      }


    })

  },
  watch: {
    selectedRows: function (new_isData, old_isData) {
      

      if(this.selectedRows.length > 0){
        this.searchString = "";

        let vue = this;

        let obj = {
          categoryId: this.$store.getters.selectedTreeItemObject.categoryId
        }
        this.$store.dispatch(this.$store.getters.sectionPrefix+"_getProperties", obj)
        .then ((result) => {

          if (result.status == "OK"){


            for (let i = 0, lei = result.data.length; i < lei; i++){

              if (result.data[i].isSearchString == true){

                for (let el in vue.selectedRows[0]){

                  if (vue.selectedRows[0][el].propertyId == result.data[i].propertyId){
                    if (vue.selectedRows[0][el].value != null){

                      if (vue.selectedRows[0][el].value.display != null){
                        vue.searchString += vue.selectedRows[0][el].value.display + " ";
                      }


                    }

                  }
                }
              }


            }


          }


        })

      }





    },
    providers: function (new_Val, old_Val) {

      let obj = {
        searchString: this.searchString,
        choosenProviders: this.providers
      }
      this.$store.dispatch("setSearchingObject", obj);

    },
    searchString: function (new_Val, old_Val) {

      let obj = {
        searchString: this.searchString,
        choosenProviders: this.providers
      }
      this.$store.dispatch("setSearchingObject", obj);

    }

  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    initial(){


      if (this.$store.getters.searchingObject.searchString != ""){
        this.searchString = this.$store.getters.searchingObject.searchString;
      }
      if (this.$store.getters.searchingObject.choosenProviders.length > 0){
        this.providers = this.$store.getters.searchingObject.choosenProviders;
      }

    },
    reset(){
      this.searchString = ""
      this.providers = [];
      var obj = {
        searchString: "",
        choosenProviders: []
      }
      this.$store.dispatch("setSearchingObject", obj);
    },
    searchOutside(){
      this.searchError = false;
      this.searchStatus = true


      var obj = {
        searchString: this.searchString.trim(),
        choosenProviders: this.providers
        }
      this.$store.dispatch("setSearchingObject", obj);

      

      var _vue = this

      var data = this.$store.dispatch(this.$store.getters.sectionPrefix+"_executeExternalSearch", obj)
        .then(function(result){

          
          if (result != undefined){
            console.log(result)



            if (result.status == "OK"){

              _vue.$store.dispatch("externalSearchResponse", result.data);

              _vue.searchStatus = false;


              if (_vue.parent == "PartSearch"){

              }else{
                _vue.$store.dispatch("setView", "PartSearch");

                let to = "PartSearch";

                

                const query = {
                  from: _vue.$route.path,
                  to: to,
                  
                }

                _vue.$router.push({ path: to, query: query });

              }



            }else{

              const obj = {
                text: _vue.lang.alert_error_Searching + ": " + result.message,
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);

              
              _vue.searchStatus = false;
              _vue.searchError = true;
            }
          }else{
         
            _vue.searchStatus = false;
            _vue.searchError = true;
          }


      })

    }

  }
}
</script>


<style lang="scss">
  .SearchComponent{
    .searching{
      margin-left: 50px;
      margin-top: 20px;
    }
    .button{
      margin-left: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/SearchComponent.vue